import React from 'react';

/* Atoms */
import { Button } from 'js/components/atoms';

/* Symbols */
import buttonIcon from 'symbols/arrow.svg';

export default function Card({
     baseClass = 'card',
     modifierClasses = [],
     className = '',
     type,
     image,
     date,
     title,
     text,
     button,
}) {
    if (button) modifierClasses.push(`${baseClass}--link`);
    if (type) modifierClasses.push(`${baseClass}--${type}`);

    return (
        <div className={[baseClass, className, ...modifierClasses].join(' ')}>
            <div className="card__image">
                <img
                    {...{
                        src: '',
                        alt: title,
                    }}
                    {...image}
                    className="img-fluid"
                />
            </div>
            <div className="card-body">
                <div className="mb-auto">
                    {date ? (
                        <p className="card__date">
                            {new Intl.DateTimeFormat('nl-NL', { dateStyle: 'short' }).format(date)}
                        </p>
                    ) : null}
                    {title ? (
                        <p className="card__title">
                            {title}
                        </p>
                    ) : null}
                    {text ? (
                        <div className="card__text" dangerouslySetInnerHTML={{ __html: text }}></div>
                    ) : null}
                </div>
                {button ? (
                    <div className="card__button">
                        <Button
                            {...{
                                theme: 'outline',
                                className: 'stretched-link',
                                icon: buttonIcon,
                            }}
                            {...button}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
}
